import { CloudDownload as DownloadIcon } from "@mui/icons-material";
import { Fab as FloatingActionButton } from "@mui/material";
import { useState } from "react";
import { getOrdersCsv } from "../ordersApi";
import CsvExportDialog from "./CsvExportDialog";

const OrdersCsvExport = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <div>
      <FloatingActionButton color="secondary" title="Zamówienia" onClick={() => setDialogOpen(true)}>
        <DownloadIcon />
      </FloatingActionButton>
      <CsvExportDialog
        title="Pobierz zamówienia"
        filename="zamowienia.csv"
        downloadErrorMessage="Nie udało się pobrać pliku CSV z zamówieniami"
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onDownload={getOrdersCsv}
      />
    </div>
  );
};

export default OrdersCsvExport;
